import { Typography } from '@mui/material';
import '../components/Studio/Studio.css'

export const renderBracketedText = (text: string) => {
  const match = text.match(/^\[(.*?)\]\s*(.*)$/);

  if (!match) {
    return (
      <Typography variant="body2" className='text-normal'>
        {text}
      </Typography>
    );
  }

  const [, bracketText, restText] = match;

  return (
    <>
      <Typography
        variant="body2"
       className='text-bracket'
      >
        [{bracketText}]{' '}
      </Typography>
      <Typography
        variant="body2"
        className='text-normal'
      >
        {restText}
      </Typography>
    </>
  );
};
